<template>
  <div>
    <a-card  v-if="MasterStatementList":bordered="false">
      <div class="table-page-search-wrapper">
        <!--查询 清空-->
        <span class="table-page-search-submitButtons">
          <a-row type="flex" justify="space-between">
            <a-col :span="8"></a-col>
            <a-col :span="13" :style="{ textAlign: 'right' }">
<!--              查询功能待完善 只能查询公司名-->
             <a-upload
               style="margin-left: 8px"
               name="file"
               :action="uploadUrl"
               @change="handleChange"
               :headers="headers"
               accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
               :showUploadList="false"
             >
              <a-button type="primary" v-if="importSettlement">

               对账单导入结算
              </a-button>
                </a-upload>
                <a-upload
                  style="margin-left: 8px"
                  name="file"
                  :action="orderuploadUrl"
                  @change="orderhandleChange"
                  :headers="headers"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                  :showUploadList="false"
                >
              <a-button type="primary" v-if="importSettlement">

               订单导入结算
              </a-button>
            </a-upload>
              <a-button type="primary"
                        style="margin-left: 8px; " v-if="exportOrderMasterStatement"
                        @click="orderExport">导出订单</a-button>
              <a-button v-if="exportMasterStatement" type="primary"
                        style="margin-left: 8px;" @click="exportEnt()">导出对账单</a-button>
            </a-col>
          </a-row>
        </span>
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅姓名" style="margin-left: 45px">
                <a-input v-model.trim="queryParam.masterName"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅联系方式"  style="margin-left: 15px">
                <a-input v-model.trim="queryParam.masterPhone"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="账单状态" style="margin-left: 45px">
                <a-select  v-model="queryParam.statementStatus" :allowClear="true">
                  <a-select-option  v-for="type in statement_status" :title="type.dictLabel":key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅负责人" :labelCol="labelCol" :wrapperCol="wrapperCol"style="margin-left: 30px">
                <a-select  v-model="queryParam.masterPrincipal" :allowClear="true">
                  <a-select-option  v-for="type in masterPrincipal" :title="type.userName":key="type.userId">{{type.userName}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="师傅类型" style="margin-left: 45px">
                <a-select v-model="queryParam.masterType" :allowClear="true">
                  <a-select-option  v-for="type in worker_type" :title="type.dictLabel":key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="结算方式" style="margin-left: 45px">
                <a-select v-model="queryParam.settleMethod" :allowClear="true">
                  <a-select-option  v-for="type in cash_status" :title="type.dictLabel":key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="结算周期" style="margin-left: 45px">
                <a-select v-model="queryParam.settleCycle" :allowClear="true">
                  <a-select-option  v-for="type in cash_cycle" :title="type.dictLabel":key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="结算状态" style="margin-left: 45px">
                <a-select v-model="queryParam.settleStatus" :allowClear="true">
                  <a-select-option  v-for="type in settlement_status" :title="type.dictLabel":key="type.dictValue">{{type.dictLabel}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item  label="客户姓名" style="margin-left: 45px">
                <a-input v-model.trim="queryParam.customerName"/>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item  label="客户联系方式" style="margin-left: 15px">
                <a-input v-model.trim="queryParam.customerMobile"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-row :gutter="24" style="margin-left: 0px">
                <a-form-item  label="客户地址"style="margin-left: 45px">
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.provinceId"
                              @change="getselect" :allowClear="true">
                      <a-select-option  v-for="type in selectAllProvince" :title="type.provinceName":key="type.provinceCode">{{type.provinceName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.cityId"
                              @change="getprovinceName" :allowClear="true">
                      <a-select-option  v-for="type in selectCityName" :title="type.cityName":key="type.cityCode">{{type.cityName}}</a-select-option>
                    </a-select >
                  </a-col>
                  <a-col :md="5" :sm="24">
                    <a-select  v-model="queryParam.areaId"  :allowClear="true">
                      <a-select-option  v-for="type in selectAreaName" :title="type.areaName":key="type.areaCode">{{type.areaName}}</a-select-option>
                    </a-select>
                  </a-col>
                  <a-col :md="9" :sm="24">
                    <a-input v-model.trim="queryParam.customerAddr"/>
                  </a-col>
                </a-form-item>
              </a-row>
            </a-col>
          </a-row>
          <a-row :gutter="24">
            <a-col :md="6" :sm="24">
              <a-form-item label="结算超期" style="margin-left: 45px">
                <a-select    v-model="queryParam.isOverDue" :allowClear="true">
                  <a-select-option value="1" title="是">
                    是
                  </a-select-option>
                  <a-select-option value="0" title="否">
                    否
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单号" style="margin-left: 60px">
                <a-input v-model.trim="queryParam.orderNo" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单总计" :labelCol="labelCol" :wrapperCol="wrapperCol" style="margin-left: 45px">
                <a-col :span="11">
                  <a-input placeholder="最小值" v-model.trim="queryParam.orderTotalNumBegin"/>
                </a-col>
                <a-col :span="2" style="display: flex;justify-content: center">
                  -
                </a-col>
                <a-col :span="11">
                  <a-input placeholder="最大值" v-model.trim="queryParam.orderTotalNumEnd"/>
                </a-col>
              </a-form-item>

            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单完成时间" style="margin-left: 15px">
                <a-range-picker   v-model="completeTime"
                                  style="width: 100%"
                                  :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                                  format="YYYY-MM-DD HH:mm:ss"@change="onChange_completeOrder" />
              </a-form-item>
            </a-col>
          </a-row>
          <div v-if="Ifstatus">
            <a-row :gutter="24">
              <a-col :md="6" :sm="24">
                <a-form-item label="预计结算日期" style="margin-left: 15px">
                  <a-range-picker   v-model="settleExpect" style="width: 100%"
                                    :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                                    format="YYYY-MM-DD HH:mm:ss"@change="onChange_settleExpect"  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="建单时间" style="margin-left: 45px">
                  <a-range-picker   v-model="createTime" style="width: 100%"
                                    :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                                    format="YYYY-MM-DD HH:mm:ss"@change="onChange_e"  />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="结算日期" style="margin-left: 45px">
                  <a-range-picker   v-model="settleTime"
                                    style="width: 100%"
                                    :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                                    format="YYYY-MM-DD HH:mm:ss"@change="onChange_settleTime" />
                </a-form-item>
              </a-col>
              <a-col :md="6" :sm="24">
                <a-form-item label="生成对账单时间">
                  <a-range-picker  v-model="createStatement"
                                   style="width: 100%"
                                   :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                                   format="YYYY-MM-DD HH:mm:ss" @change="onChange_d"  />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="账单截止日期" style="margin-left: 15px">
                  <a-range-picker   v-model="closingDate"
                                    style="width: 100%"
                                    :show-time="{ hideDisabledOptions: true, defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')], }"
                                    format="YYYY-MM-DD HH:mm:ss" @change="onChange_a"  />
                </a-form-item>
              </a-col>

              <a-col :md="6" :sm="24">
                <a-form-item label="对账单编号" style="margin-left: 30px">
                  <a-input v-model.trim="queryParam.statementNo"/>
                </a-form-item>
              </a-col>

            </a-row>
          </div>

          <a-row>
            <a-col :span="1" :offset="11">
              <span v-if="Ifstatus == 0" style="cursor:pointer" @click="getMore"><a-icon type="down-circle" theme="twoTone" style="fontSize:24px"/></span>
              <span v-if="Ifstatus == 1" style="cursor:pointer" @click="hiddenMore"><a-icon type="up-circle" theme="twoTone" style="fontSize:24px"/></span>
            </a-col>
            <a-col :span="12" :style="{ textAlign: 'right' }">
              <a-button type="primary" htmlType="submit" @click="getdataList1(1)">查询</a-button>
              <a-button style="margin-left: 8px" @click="empty()">清空</a-button>
            </a-col>
          </a-row>
          <a-divider/>
          <div class="table-operator">
            <a-row>
              <a-col :span="10"></a-col>
              <a-col :span="6">

              </a-col>
              <a-col :span="8" :style="{ textAlign: 'right' }">
                <!-- 查询功能待完善 只能查询公司名-->
                <a-button type="primary" style="width: 120px;"v-if="batchsettlementMasterStatement" @click="goBillSettlement()" :disabled="!hasSelected">批量结算</a-button>
                <a-button style="margin-left: 8px;width: 120px;"v-if="removeMasterStatement" :disabled="!hasSelected" @click="batchRemoval()">批量移除对账单</a-button>
              </a-col>
            </a-row>
          </div>


        </a-form>
      </div>
      <!--    表格内容-->
      <a-table
        size="default"
        ref="table"
        rowKey="sourceId"
        :columns="columns"
        :dataSource="this.subList.rows"
        bordered
        :pagination="false"
        :scroll="{ x: 3200}"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        :rowClassName='setClassName'
      >

      <span slot="action" slot-scope="text, record" style="white-space: nowrap;">
        <!--生成对账单按钮-->
        <a v-if="viewStatementDetails" @click="edit(record)">编辑</a>
        <a-divider type="vertical" v-if="singlesettlementMasterStatement&&record.settleStatusCode!=2" />
        <!--查看按钮-->
          <a  v-if="singlesettlementMasterStatement&&record.settleStatusCode!=2" @click="goSettlement(record)">结算</a>
        <a-divider type="vertical"  v-if="remarkMasterStatement"/>
        <!--备注按钮-->
         <a  v-if="remarkMasterStatement" @click="remarkList(record)">备注</a>
         <a-divider type="vertical" v-if="removeMasterStatement"/>
         <a  v-if="removeMasterStatement"  @click="remove(record)">移除</a>
      </span>
      </a-table>

      <a-pagination showQuickJumper="true" showSizeChanger
                    :pageSizeOptions="pageSizeOptions"
                    :pageSize.sync="pageSize"
                    @showSizeChange="onShowSizeChange"
                    :total="total"
                    v-model="current"
                    @change="getdataList1"
                    :showTotal="total => `总共 ${total} 条`"
                    style="text-align: end;margin-top: 20px"
      />

      <!--    最后字段第一行-->
      <a-row v-if="subList.statistics">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5" >
            </a-col>
            <a-col :span="19" style="text-align: center">
              <span style="font-size: 14px;font-weight: 700" v-if="viewPriceMasterStatement">【企业】订单总金额：{{subList.statistics.enterpriseTotalAmount}}元   结算总金额：{{subList.statistics.enterpriseSettleAmount}}元  </span>

              <span style="font-size: 14px;font-weight: 700">【师傅】订单总金额：{{subList.statistics.masterTotalAmount}}元  结算总金额：{{subList.statistics.masterSettleAmount}}元  </span>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <!--    最后字段第二行-->
      <a-row v-if="subList.statistics">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5" >
            </a-col>
            <a-col :span="19" style="text-align: center">
              <span style="font-size: 14px;font-weight: 700;text-align: center">成本：{{subList.statistics.cost}}元    毛利：{{subList.statistics.grossProfit}}元     结算扣款：{{subList.statistics.deduction}}元    已退款金额：{{subList.statistics.alreadyRefundAmount}}元   订单总计：{{subList.statistics.orderNum}}单     </span>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row v-if="subList.statistics">
        <a-col :span="19" style="margin: 10px 0">
          <a-row>
            <a-col :span="5" >
            </a-col>
            <a-col :span="19" style="text-align: center">
              <span style="font-size: 14px;font-weight: 700;text-align: center">结算金额：{{subList.statistics.enterpriseSettleAmount}}元       已结算金额：{{subList.statistics.alreadySettleAmount}}元     实际需结算：{{subList.statistics.needSettleAmount}}元    已退款金额：{{subList.statistics.alreadyRefundAmount}}元   订单总计：{{subList.statistics.orderNum}}单    </span>
            </a-col>
          </a-row>
        </a-col>
      </a-row>
      <!--    移除的弹框提醒-->
      <!--    移除对账单确定按钮-->
      <a-modal
        title="移除"
        style="top: 20px;"
        :width="800"
        v-model="removeible"
        :confirmLoading="confirmLoading"
        @ok="confirmOk"
        @cancel="confirmCancel"
      >
        <p>确定移除该条对账单吗？</p>
      </a-modal>
      <a-modal
        title="备注"
        style="top: 20px;"
        :width="900"
        :visible="remarkible"
        @ok="remarkconfirmOk"
        @cancel="remarkCancel"
      >
        <a-form :form="form">
          <a-form-item style="display:none">
            <a-input v-decorator="['statementId']"/>
          </a-form-item>
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
            <a-input  v-decorator="['remark']"/>
          </a-form-item>
        </a-form>
      </a-modal>
      <a-modal
        title="对账单导入失败文件"
        style="top: 20px;"
        v-model="bisible"
        @ok="handleSubmit"
        :closable="false"
        :maskClosable="false"
      >
        <div style="margin-left: 50px">
          <p v-if="this.message">
            {{message}}
          </p>
          <strong>是否下载导入失败文件？</strong>
        </div>
      </a-modal>
      <a-modal
        title="订单导入失败文件"
        style="top: 20px;"
        v-model="orderbisible"
        @ok="orderhandleSubmit"
        :closable="false"
        :maskClosable="false"
      >
        <div style="margin-left: 50px">
          <p v-if="this.ordermessage">
            {{ordermessage}}
          </p>
          <strong>是否下载导入失败文件？</strong>
        </div>
      </a-modal>

      <master-single-model ref="master" @ok="query"></master-single-model>
      <master-sub-settlement-model ref="mastersubsettlement" @ok="query"></master-sub-settlement-model>

    </a-card>
    <no-authority v-else></no-authority>
  </div>

</template>
<script>
  import NoAuthority from '../enterprise/NoAuthority'
  import moment from 'moment';
  import masterSingleModel from'./modules/masterSingleModel'
  import masterSubSettlementModel from'./modules/masterSubSettlementModel'
  import { saveRemark } from '@/api/finance/enterpriseStatement'
  import pick from 'lodash.pick'
  import {getList,getselectAllProvince,getselectCityName,getselectAreaName,getmarketPrincipal,getSelectBrand,getOrderDetail,getSelectModel,getfindByDeptId,getmasterPrincipal,getfinddictAll} from
      '@/api/order/orderList'
  import { STable } from '@/components'
  import {
    getSourceList,getSettleList,getEditList,removeSettleList,getexportList,getorderExport,getdownloadFailedDataOrder,getdownloadFailedDat} from
      '@/api/finance/MasterStatementList'
  import CustomerModal from './modules/CustomerModal.vue'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"
  import {ACCESS_TOKEN} from '@/store/mutation-types'
  export default {
    name: 'MasterStatementList',
    components: {
      STable,
      // 注册弹框组件
      CustomerModal,
      masterSingleModel,
      masterSubSettlementModel,
      NoAuthority
    },
    data () {
      return {

        // 分页
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        total:0,
        current:1,
        pageSize:10,

        bisible:false,
        orderbisible:false,
        Ifstatus:0,
        success: '',
        err: '',
        arrList:'',
        orderarrList:'',
        message:'',
        ordermessage:'',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        uploadUrl: process.env.VUE_APP_API_BASE_URL + '/finance/masterController/importSettle',
        orderuploadUrl: process.env.VUE_APP_API_BASE_URL + '/finance/masterController/orderImportSettle',
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        masterPrincipal:[],
        // 省
        selectAllProvince:[],
        // 市
        selectCityName:[],
        // 区
        selectAreaName:[],
        settlement_status: [],
        statement_status: [],
        master_settle_cycle: [],
        master_settle_method: [],
        cash_cycle: [],
        cash_status: [],

        worker_type: [],
        subList:'',
        // 批量结算包存的id
        statementIds:[],
        // 批量结算相应的数据
        reslist:[],
        // 移除按钮
        removeible:false,
        removeLoading:false,
        // 根据单个id获取到的子对账单的数据
        Settlementlist:[],
        selectedRowKeys: [], // Check here to configure the default column
        selectedRow:[],
        disabled:true,
        settleExpect:'',
        createTime:'',
        completeTime:'',
        settleTime:'',
        closingDate:'',
        createStatement:'',
        loading: false,
        remarkible: false,
        form: this.$form.createForm(this),
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'rowNum',
            align:'center'
          },
          {
            title: '操作栏',
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },

          },
          {
            title: '账单状态',
            dataIndex: 'statementStatus',
            align:'center'
          },
          {
            title: '账单号',
            dataIndex: 'statementNo',
            align:'center'
          },
          {
            title: '账单截止日期',
            dataIndex: 'closingDate',
            align:'center'
          },
          {
            title: '师傅姓名',
            dataIndex: 'masterName',
            align:'center'
          },

          {
            title: '联系方式',
            dataIndex: 'masterPhone',
            align:'center'
          },
          {
            title: '师傅类型',
            dataIndex: 'masterType',
            align:'center'
          },          {
            title: '结算方式',
            dataIndex: 'settleMethod',
            align:'center'
          },  {
            title: '结算周期',
            dataIndex: 'settleCycle',
            align:'center'
          },  {
            title: '结算状态',
            dataIndex: 'settleStatus',
            align:'center'
          },  {
            title: '结算日期',
            dataIndex: 'settleTime',
            align:'center'
          },
          {
            title: '订单总计',
            dataIndex: 'orderNum',
            align:'center'
          },
          {
            title: '安装数量',
            dataIndex: 'installNum',
            align:'center'
          }  ,
          // {
          //   title: '帐单数',
          //   dataIndex: 'subStatementNum',
          //   align:'center'
          // },
          {
            title: '师傅订单总金额',
            dataIndex: 'masterTotalAmount',
            align:'center'
          },
          {
            title: '师傅结算总金额',
            dataIndex: 'masterSettleAmount',
            align:'center'
          },
          {
            title: '企业订单总金额',
            dataIndex: 'enterpriseTotalAmount',
            className: this.viewPriceMasterStatement?'':'notshow',
            align:'center'
          },{
            title: '企业结算总金额',
            dataIndex: 'enterpriseSettleAmount',
            className: this.viewPriceMasterStatement?'':'notshow',
            align:'center'
          },{
            title: '成本',
            dataIndex: 'cost',
            align:'center'
          },{
            title: '毛利',
            dataIndex: 'grossProfit',
            align:'center'
          },{
            title: '结算扣款',
            dataIndex: 'deduction',
            align:'center'
          },{
            title: '已结算金额',
            dataIndex: 'alreadySettleAmount',
            align:'center'
          },{
            title: '实际需结算',
            dataIndex: 'needSettleAmount',
            align:'center'
          },{
            title: '已退款金额',
            dataIndex: 'alreadyRefundAmount',
            align:'center'
          },
          {
            title: '预计结算日期',
            dataIndex: 'expectSettleDate',
            align:'center'
          },{
            title: '师傅负责人',
            dataIndex: 'masterPrincipal',
            align:'center'
          },{
            title: '户名',
            dataIndex: 'accountName',
            align:'center'
          },{
            title: '开户行',
            dataIndex: 'bank',
            align:'center'
          },{
            title: '银行卡账号',
            dataIndex: 'bankCardNo',
            align:'center'
          },{
            title: '生成对账单时间',
            dataIndex: 'createStatementTime',
            align:'center'
          },
          {
            title: '备注',
            dataIndex: 'remark',

          }
        ],
        // // 加载数据方法 必须为 Promise 对象
        // loadData: parameter => {
        //   return getSourceList(Object.assign(parameter, this.queryParam))
        // },
        data:[],
        // 字典为收款状态
        installTypes:[],
        // 字典为时间类型
        timetype:[],
        // 查看企业金额
        viewPriceMasterStatement: checkPermission('viewPriceMasterStatement'),
   // 单个结算
        singlesettlementMasterStatement: checkPermission('singlesettlementMasterStatement'),
        // 批量结算
        batchsettlementMasterStatement: checkPermission('batchsettlementMasterStatement'),
        // 导出对账单
        exportMasterStatement: checkPermission('exportMasterStatement'),
        // 查看对账单详情
        viewStatementDetails: checkPermission('viewStatementDetails'),
        // 导出订单
        exportOrderMasterStatement: checkPermission('exportOrderMasterStatement'),
        // 导入结算
        importSettlement: checkPermission('importSettlement'),
        // 备注
        remarkMasterStatement: checkPermission('remarkMasterSingle'),
        // 移除
        removeMasterStatement: checkPermission('removeMasterSingle'),
        MasterStatementList: checkPermission('MasterStatementList:query:list'),

      }
    },
    filters: {
    },
    // 下拉框的选项
    async created () {
      // 订单负责人
      this.masterPrincipal = [];
      await getmasterPrincipal().then(res => {
        this.masterPrincipal = res
      })
      await  getselectAllProvince().then(res=>{
        if(res.code===0){
          this.selectAllProvince= res.rows
        } else {
          this.$message.error(res.msg);
        }
      })
      this.getdataList1(1)

      let dictTypes=['settlement_status','worker_type','cash_status','cash_cycle','master_settle_method','statement_status','master_settle_cycle']
      getfinddictAll({dictTypes:dictTypes.join()}).then(res => {
        this.worker_type=res.worker_type
        this.master_settle_method=res.master_settle_method
        this.settlement_status=res.settlement_status
        this.statement_status=res.statement_status
        this.master_settle_cycle=res.master_settle_cycle
        this.cash_status=res.cash_status
        this.cash_cycle=res.cash_cycle

      })
    },
    // 计算选中的按钮的显示和隐藏
    computed: {
      hasSelected() {
        return this.selectedRowKeys.length > 0;
      },
    },
    methods: {

      // 分页
      onShowSizeChange(current, pageSize) {
        this.pageSize = pageSize;
        this.getdataList1(current)
      },

      getdataList1(value){
        this.current = value
        this.queryParam.pageNum = value
        this.queryParam.pageSize = this.pageSize
        this.handloadData()
      },
      handloadData() {
        getSourceList(this.queryParam).then(res => {
          console.log(res)
          this.subList = res
          this.total = res.total
        })
      },

      SetOptionTitle(){
        var selects = document.getElementsByTagName("select");
        if (selects.length > 0) {
          for (var i = 0; i < selects.length; i++) {
            var options = selects[i].options;
            if (selects[i].options.length > 0) {
              for (var j = 0; j < options.length; j++) {
                if (options[j].title == "")
                  options[j].title = options[j].text;
              }
            }
          }
        }
      },
      empty(){
        this.queryParam={}
        this.settleExpect=''
        this.createTime=''
        this.settleTime=''
        this.closingDate=''
        this.completeTime=''
        this.createStatement=''
      },
      // 更多、隐藏
      getMore(){
        this.Ifstatus = 1
      },
      hiddenMore(){
        this.Ifstatus = 0
      },
      moment,
      setClassName(record){
        // console.log(record)
        if(record.isOverDue == '是' ){//超时订单
          return 'clickRowStyle'
        }
      },
      // 失败文件处理
      handleSubmit(){
        // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var date = new Date()
        var Y = date.getFullYear()
        var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
        var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
        var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
        var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
        var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
        var ms = ''
        if (date.getMilliseconds() < 10) {
          ms = '00' + date.getMilliseconds()
        } else if (date.getMilliseconds() < 100) {
          ms = '0' + date.getMilliseconds()
        } else {
          ms = date.getMilliseconds()
        }
        getdownloadFailedDat(this.arrList).then(res=>{
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          const a = document.createElement('a')
          // 生成文件路径
          let href = window.URL.createObjectURL(blob)
          a.href = href
          // let fileName = '导入失败型号文件'
          let fileName = Y + M + D + h + m + s + ms + '_对账单结算文件失败'
          // 文件名中有中文 则对文件名进行转码
          a.download = decodeURIComponent(fileName)
          // 利用a标签做下载
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(href)
        })
      },
      orderhandleSubmit(){
        // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var date = new Date()
        var Y = date.getFullYear()
        var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
        var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
        var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
        var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
        var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
        var ms = ''
        if (date.getMilliseconds() < 10) {
          ms = '00' + date.getMilliseconds()
        } else if (date.getMilliseconds() < 100) {
          ms = '0' + date.getMilliseconds()
        } else {
          ms = date.getMilliseconds()
        }
        getdownloadFailedDataOrder(this.orderarrList).then(res=>{
          const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
          const a = document.createElement('a')
          // 生成文件路径
          let href = window.URL.createObjectURL(blob)
          a.href = href
          let fileName = Y + M + D + h + m + s + ms + '_订单结算失败文件'
          // 文件名中有中文 则对文件名进行转码
          a.download = decodeURIComponent(fileName)
          // 利用a标签做下载
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(href)
        })
      },
      handleChange(info) {
        // console.log(info)
        if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {

          let file = info.file.response.data
          this.$message.success(file.message)
         // console.log(file);
          if(file. failedData.length > 0){
            this.message=file.message
            this.bisible = true
            this.arrList=file.failedData
          }
        }
        if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }
      },
      orderhandleChange(info) {
        // console.log(info)
        if (info.file.status !== 'uploading') {
          // console.log(info.file, info.fileList);
        }
        if (info.file.status === 'done') {
          let file = info.file.response.data
          this.$message.success(file.message)
          if(file. failedData.length > 0){
            this.ordermessage=file.message
            this.orderbisible = true
            this.orderarrList=file.failedData
          }
        }
        if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }
      },
      orderExport(){
        this.statementIds=[]
        var str=process.env.VUE_APP_API_BASE_URL + '/finance/masterController/newOrderExport?'
        for(let i in this.queryParam ){
          if(this.queryParam[i]!=undefined){
            str=str+'&'+i+'='+this.queryParam[i]
          }
        }
        if(this.selectedRowKeys.length>0) {
          this.selectedRow.forEach(item => {
            return this.statementIds.push(item.statementId)
          });
          for(let i in this.statementIds ){
            if(this.statementIds[i]!=undefined){
              str=str+'&statementIds='+this.statementIds[i]
            }
          }
        }
        str=str+'&token='+this.headers.token
        window.open(str)

      },
      exportEnt () {
        var str=process.env.VUE_APP_API_BASE_URL + '/finance/masterController/listExport?pageNum=1&pageSize=10'
        for(let i in this.queryParam ){
          if(this.queryParam[i]!=undefined){
            str=str+'&'+i+'='+this.queryParam[i]
          }
        }

        str=str+'&token='+this.headers.token
        window.open(str)
        // 时间戳为10位需*1000，时间戳为13位的话不需乘1000
        // var date = new Date()
        // var Y = date.getFullYear()
        // var M = ((date.getMonth() + 1) < 10) ? ('0' + (date.getMonth() + 1)) : ((date.getMonth() + 1))
        // var D = (date.getDate() < 10) ? ('0' + date.getDate()) : (date.getDate())
        // var h = (date.getHours() < 10) ? ('0' + date.getHours()) : (date.getHours())
        // var m = (date.getMinutes() < 10) ? ('0' + date.getMinutes()) : (date.getMinutes())
        // var s = (date.getSeconds() < 10) ? ('0' + date.getSeconds()) : (date.getSeconds())
        // var ms = ''
        // if (date.getMilliseconds() < 10) {
        //   ms = '00' + date.getMilliseconds()
        // } else if (date.getMilliseconds() < 100) {
        //   ms = '0' + date.getMilliseconds()
        // } else {
        //   ms = date.getMilliseconds()
        // }

        // getexportList(this.queryParam).then(res => {
        //   const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' })
        //   const a = document.createElement('a')
        //   // 生成文件路径
        //   let href = window.URL.createObjectURL(blob)
        //   a.href = href
        //   let fileName = Y + M + D + h + m + s + ms + '_师傅对账单'
        //   // 文件名中有中文 则对文件名进行转码
        //   a.download = decodeURIComponent(fileName)
        //   // 利用a标签做下载
        //   document.body.appendChild(a)
        //   a.click()
        //   document.body.removeChild(a)
        //   window.URL.revokeObjectURL(href)
        // })
      },
      query(){
        this.selectedRowKeys=[]
        this.selectedRows=[]
        getSourceList(this.queryParam).then(res=>{
          if (res.code===0){
            this.subList=res
            this.total = res.total
            this.getdataList1(this.current)
            // for (let a=0 ;a<=this.subList.rows.length;a++){
            //   this.subList.rows[a].serialNumber=a+1
            //   }
          }else {
            this.$message.error(res.msg);
          }
        })

      },
      remarkCancel(){
        this.remarkible=false
      },
      remarkList(record){
        this.remarkible=true
        this.form.resetFields()
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(record, 'remark','statementId'))
        })
      },
      remarkconfirmOk(){
        this.remarkible=false
        this.form.validateFields((err, values) => {
          values.statementType=1
          if (!err) {
            saveRemark(values).then(res=>{
              if (res.code===0){
                this.$message.success('操作成功')
                this.getdataList1(this.current)
              }else {
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
      // 市
      getselect(e){
        getselectCityName({provinceCode :e}).then(res=>{
          if(res.code===0){
            console.log(res)
            this.selectCityName= res.rows;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 区
      getprovinceName(e){
        getselectAreaName({cityCode:e}).then(res=>{
          if(res.code===0){
            console.log(res)
            this.selectAreaName= res.rows;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 编辑按钮
      edit(record){

        this.$refs.master.showmasterSingle(record.statementId)

      },
      // 批量移除对账单
      batchRemoval(){
        this.statementIds=[]
        if(this.selectedRowKeys.length>0) {
          this.removeible = true;
          this.selectedRow.forEach(item => {
            return this.statementIds.push(item.statementId)
          });
        }
      },
      // 移除按钮      // 移除
      remove(record){
        this.statementIds=[]
        this.removeible = true;
        this.statementIds.push(record.statementId)
      },
      // 移除确定时调用的方法
      async confirmOk(){
        this.removeible = false;
        this.removeLoading = false;
        console.log(this.statementIds)
        await removeSettleList({statementId:this.statementIds.join()}).then(res=>{
            if (res.code===0){
              this.getdataList1(this.current)
            }else {
              this.$message.error(res.msg)
            }
          }
        )
      },
      // 移除取消时调用的方法
      confirmCancel(){
        this.removeible = false;
      },
      // 账单截止日期
      onChange_a(date, dateString) {
        this.queryParam.closingDateBegin=dateString[0]
        this.queryParam.closingDateEnd=dateString[1]
      },
      onChange_d(date, dateString) {
        this.queryParam.createStatementTimeBegin=dateString[0]
        this.queryParam.createStatementTimeEnd=dateString[1]
      },
      onChange_e(date, dateString) {
        this.queryParam.createOrderTimeBegin=dateString[0]
        this.queryParam.createOrderTimeEnd=dateString[1]
      },
      onChange_completeOrder(date, dateString) {
        this.queryParam.completeOrderTimeBegin=dateString[0]
        this.queryParam.completeOrderTimeEnd=dateString[1]
      },
      onChange_settleTime(date, dateString) {
        this.queryParam.settleTimeBegin=dateString[0]
        this.queryParam.settleTimeEnd=dateString[1]
      },
      onChange_settleExpect(date, dateString) {
        this.queryParam.settleExpectDateBegin=dateString[0]
        this.queryParam.settleExpectDateEnd=dateString[1]
      },
      handleChangeMin(e){
        this.queryParam.orderTotalNumBegin=e.target.value
      },
      handleChangeMax(e){
        this.queryParam. orderTotalNumEnd=e.target.value
      },
      // 结算跳转页面
      goSettlement(record){
        console.log(record.statementId)
        this.$refs.mastersubsettlement.showmastersubsettlement(record.statementId)

      },
      // 复选框change事件
      onSelectChange(selectedRowKeys,selectedRow) {
        this.selectedRow=selectedRow
        this.selectedRowKeys = selectedRowKeys;
       // console.log(this.selectedRow)
      },
      // 批量结算按钮 跳转
      goBillSettlement(){
        // 有选中的值传id
        this.statementIds=[]
        // 有选中的值传id
        if(this.selectedRowKeys.length>0){
          this.selectedRow.forEach(item => {
            return this.statementIds.push(item.statementId)
          });
          this.$refs.mastersubsettlement.showmastersubsettlement(this.statementIds)
              // this.$router.push({name:'masterSubSettlement',params:{
              //     statementId:this.statementIds
              //   }})
          // console.log(this.statementIds)
          // getSettleList({statementIds:this.statementIds.join()}).then(res=>{
          //   if (res.code===0){
          //     // // 响应的数据
          //     // console.log(res)
          //     this.reslist=res.data

          //   }else {
          //     this.$message.error('请求错误');
          //   }
          // })
        }
      },
      handleAdd () {
        this.$refs.modal.add()
      },
      ConfirmReceipt(record){
        this.$refs.modal.confirmReceipt(record)
      },
      confirmRefund(){
        this.$refs.modal.confirmRefund()
      },
      handleremark(record){
        this.$refs.modal.remark()
      },

    },
    watch: {
    }
  }
</script>
<style scoped>
  /deep/ .clickRowStyle {
    background: #ff7575;
  }
  /deep/ .clickRowStyle2 {
    background: #a4ffa1;
  }
  /deep/ .clickRowStyle3 {
    background: #f9ff9f;
  }
  /deep/ .notshow {
    display: none;
  }
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td {  white-space: nowrap;padding: 4px 16px;}
</style>